import { z } from 'zod';
import { paginationSchema } from './common.js';
export const paymentStatusSchema = z.enum(['pending', 'paid', 'overdue', 'cancelled']);
export const paymentMethodSchema = z.enum(['bank_transfer', 'cash', 'card']);
export const paymentCreateSchema = z.object({
    customerId: z.string().uuid(),
    amount: z.number().positive(),
    currency: z.enum(['TRY', 'USD', 'EUR']).default('USD'),
    dueDate: z.string().datetime(),
    description: z.string().max(500).optional(),
    invoiceNo: z.string().min(1).max(100).optional(),
});
export const paymentUpdateSchema = z.object({
    status: paymentStatusSchema.optional(),
    paidAt: z.string().datetime().optional(),
    amount: z.number().positive().optional(),
    dueDate: z.string().datetime().optional(),
    description: z.string().max(500).optional(),
    paymentMethod: paymentMethodSchema.optional(),
});
export const paymentBulkActionSchema = z.object({
    ids: z.array(z.string().uuid()).min(1).max(200),
    action: z.enum(['mark_paid', 'cancel']),
    paymentMethod: paymentMethodSchema.optional(),
});
export const paymentListQuerySchema = paginationSchema.extend({
    status: z
        .union([paymentStatusSchema, z.array(paymentStatusSchema)])
        .optional()
        .transform((v) => (v === undefined ? undefined : Array.isArray(v) ? v : [v])),
    customerId: z.string().uuid().optional(),
    currency: z.string().length(3).optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
// Allowed status transitions enforced server-side.
export const PAYMENT_STATE_TRANSITIONS = {
    pending: ['paid', 'cancelled', 'overdue'],
    overdue: ['paid', 'cancelled'],
    paid: [],
    cancelled: [],
};
export function canTransition(from, to) {
    return PAYMENT_STATE_TRANSITIONS[from]?.includes(to) ?? false;
}
